import { List, Stack, Text } from '@chakra-ui/react'
import type { PublicJoinResponse } from '@ipc/shared'
import { useT } from '~/i18n/use-t'

/**
 * What the company that did the check still has (copy v8 "Delete my registration"): one line by the provider's
 * `erasureNotice`, and "Questions about the deletion?". When the notice is not known (no check was done, or the page
 * has no way to learn the provider) only the general line is shown.
 */
export function ErasureLines({
  notice,
  provider,
}: {
  notice: PublicJoinResponse['erasureNotice'] | undefined
  provider: string | undefined
}) {
  const { t, config } = useT()
  const specific = notice && notice !== 'nothing_kept' ? true : notice === 'nothing_kept'
  return (
    <Stack gap={3}>
      {specific && provider && (
        <>
          <Text fontWeight='bold'>{t('erasure.title')}</Text>
          <List.Root ps={6}>
            <List.Item>{t(`erasure.${notice}`, { provider })}</List.Item>
          </List.Root>
        </>
      )}
      <Text>{t('erasure.questions', { contact: config.org.contact })}</Text>
    </Stack>
  )
}
